import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { Currencies } from "../currencies/currencies.entity";
import { Address } from "../customers/address.entity";
import { PaymentMode } from "../payment-mode/payment-mode.entity";
import { RackZoneMapping } from "../rack-zone-mapping/rack-zone-mapping-entity";
import { ShippingTerms } from "../shipping-terms/shipping-terms.entity";
import { Brands } from "./brands.entity";
import { EndCustomerType } from "libs/shared-models/masters/src/lib/enums/end-customer-type.enum";
import { RegistrationType } from "libs/shared-models/masters/src/lib/enums/registration-type.enum";
import { TcsApplicable } from "libs/shared-models/masters/src/lib/enums/tcs-applicable.enum";
// import { Address } from "./address.entity";

@Entity('end_customers')
export class EndCustomers {

  @PrimaryGeneratedColumn("increment",{name:'end_customer_id'})
  endCustomerId:number;
  @Column("varchar",{
    nullable:false,
    length:100,
    name:"end_customer_code"
    })
  endCustomerCode:string;
  @Column("varchar",{
    nullable:false,
    length:100,
    name:"end_customer_name"
    })
  endCustomerName:string;
  
  @Column("int",{
    nullable:false,
    name:"currency_id"
    })
  currencyId:number;

  @Column("int",{
    nullable:false,
    name:"country_id"
    })
    countryId:number;

  @Column("varchar",{
    nullable:true,
    length:100,
    name:"state_name"
    })
    stateName:string;


    @Column({
      type: 'enum',
      enum: EndCustomerType,
      nullable: false,
      name: 'end_customer_type'
  })
  endCustomerType: string;

  @Column({
    type: 'enum',
    enum: RegistrationType,
    nullable: false,
    name: 'registration_type'
})
registrationType: string;

@Column({
    type: 'enum',
    enum: TcsApplicable,
    nullable: false,
    name: 'tcs_applicable'
})
tcsApplicable: string;

@Column("int", {
  nullable: false,
  // length: 100,
  name: "category_id"
})
category: number;


@Column("varchar",{
  nullable:false,
  name:"fax_no"
  })
  faxNo:string;

  @Column("varchar",{
    nullable:false,
    name:"phone_no"
    })
    phoneNo:string;


  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      default: "ADMIN",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })

  versionFlag: number;

  @Column("varchar", {
    nullable: false,
    name: "hts_code",
    length:50
})
htsCode: string | null;

@Column("varchar", {
  nullable: false,
  name: "consignee_address",
})
consigneeAddress: string | null;

  @ApiProperty({type:[Address]})

  @OneToMany(type => Address, address => address.endCustomerInfo, { cascade: true })
  addressInfo: Address[];

  @ApiProperty({type:[Brands]})

  @OneToMany(type => Brands, brands => brands.endCustomerBrandsInfo, { cascade: true })
  brandsInfo: Brands[];

  @ManyToOne(type=>Currencies, currency=>currency.endCustomerInfo,{  nullable:false, })
  @JoinColumn({ name:"currency_id"})
  currencyInfo: Currencies;
  
  @OneToMany(type => RackZoneMapping, rackZoneMapping => rackZoneMapping.endCustomerInfo, { cascade: true })
  rackZoneInfo: RackZoneMapping[];

  @Column("varchar", {
    name: "file_path"
  })
  filePath: string;
  
  @Column("varchar", {
    name: "file_name"
  })
  fileName: string;

  @Column("varchar",{
    nullable:false,
    length:100,
    name:"consignee_name"
    })
    consignee:string;
    @Column("varchar",{
      nullable: true,
      name:"email"
      })
      email:string;

}
